import * as SpineAnimationAssets from '../../../assets/spine/animations';
import { SpineAnimationIds } from '../../../types/animations';

export const GRSpineAnimations = {
  [SpineAnimationIds.GR_FREEBETS_WON_X1]: [
    {
      assets: SpineAnimationAssets.GRFreebetsWon,
      animation: SpineAnimationAssets.GRFreebetsWon.animations.ANIMATION,
      skin: SpineAnimationAssets.GRFreebetsWon.skins.X1,
      forwards: true,
    },
  ],
  [SpineAnimationIds.GR_FREEBETS_WON_X2]: [
    {
      assets: SpineAnimationAssets.GRFreebetsWon,
      animation: SpineAnimationAssets.GRFreebetsWon.animations.ANIMATION,
      skin: SpineAnimationAssets.GRFreebetsWon.skins.X2,
      forwards: true,
    },
  ],
  [SpineAnimationIds.GR_FREEBETS_WON_X5]: [
    {
      assets: SpineAnimationAssets.GRFreebetsWon,
      animation: SpineAnimationAssets.GRFreebetsWon.animations.ANIMATION,
      skin: SpineAnimationAssets.GRFreebetsWon.skins.X5,
      forwards: true,
    },
  ],
  [SpineAnimationIds.GR_FREEBETS_WON_X10]: [
    {
      assets: SpineAnimationAssets.GRFreebetsWon,
      animation: SpineAnimationAssets.GRFreebetsWon.animations.ANIMATION,
      skin: SpineAnimationAssets.GRFreebetsWon.skins.X10,
      forwards: true,
    },
  ],
  [SpineAnimationIds.GR_FREEBETS_WON_X20]: [
    {
      assets: SpineAnimationAssets.GRFreebetsWon,
      animation: SpineAnimationAssets.GRFreebetsWon.animations.ANIMATION,
      skin: SpineAnimationAssets.GRFreebetsWon.skins.X20,
      forwards: true,
    },
  ],

  // Gift Race
  [SpineAnimationIds.GR_SHOE]: [
    {
      assets: SpineAnimationAssets.Shoe,
      forwards: !SpineAnimationAssets.Shoe.isLoop,
      loop: SpineAnimationAssets.Shoe.isLoop,
    },
  ],
  [SpineAnimationIds.GR_BALLOON]: [
    {
      assets: SpineAnimationAssets.Balloon,
      forwards: !SpineAnimationAssets.Balloon.isLoop,
      loop: SpineAnimationAssets.Balloon.isLoop,
    },
  ],
  [SpineAnimationIds.GR_SHIRT]: [
    {
      assets: SpineAnimationAssets.Shirt,
      forwards: !SpineAnimationAssets.Shirt.isLoop,
      loop: SpineAnimationAssets.Shirt.isLoop,
    },
  ],
  [SpineAnimationIds.GR_START_FR]: [
    {
      assets: SpineAnimationAssets.GRStartFR,
      forwards: true,
    },
  ],
  [SpineAnimationIds.GR_START_EN]: [
    {
      assets: SpineAnimationAssets.GRStartEN,
      forwards: true,
    },
  ],
  [SpineAnimationIds.GR_START_ES]: [
    {
      assets: SpineAnimationAssets.GRStartES,
      forwards: true,
    },
  ],
  [SpineAnimationIds.GR_START_DE]: [
    {
      assets: SpineAnimationAssets.GRStartDE,
      forwards: true,
    },
  ],

  // Hunting All Stars
  [SpineAnimationIds.GR_HUNTING_ALL_STARS_RABBIT_1]: [
    {
      assets: SpineAnimationAssets.GRHuntingAllStarsRabbit1,
      forwards: true,
      loop: true,
    },
  ],

  [SpineAnimationIds.GR_HUNTING_ALL_STARS_RABBIT_2]: [
    {
      assets: SpineAnimationAssets.GRHuntingAllStarsRabbit2,
      forwards: true,
      loop: true,
    },
  ],

  [SpineAnimationIds.GR_HUNTING_ALL_STARS_RABBIT_3]: [
    {
      assets: SpineAnimationAssets.GRHuntingAllStarsRabbit3,
      forwards: true,
      loop: true,
    },
  ],

  [SpineAnimationIds.GR_HUNTING_ALL_STARS_PASTILLE_LOOSE]: [
    {
      assets: SpineAnimationAssets.GRHuntingAllStarsPastille,
      skin: 'Loose',
      forwards: true,
    },
  ],

  [SpineAnimationIds.GR_HUNTING_ALL_STARS_PASTILLE_DEFAULT]: [
    {
      assets: SpineAnimationAssets.GRHuntingAllStarsPastille,
      skin: 'default',
      forwards: true,
    },
  ],

  [SpineAnimationIds.GR_HUNTING_ALL_STARS_PASTILLE_WON]: [
    {
      assets: SpineAnimationAssets.GRHuntingAllStarsPastille,
      skin: 'Win',
      forwards: true,
    },
  ],

  [SpineAnimationIds.GR_HUNTING_ALL_STARS_WELCOME]: [
    {
      assets: SpineAnimationAssets.GRHuntingAllStarsWelcome,
      forwards: true,
    },
  ],
};
